var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./address-form.j2"] = require( "./address-form.j2" );
dependencies["./addresses-and-payments/no-address-message.j2"] = require( "./addresses-and-payments/no-address-message.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/add-new-address-section.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"formFocus") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"focusValue") != "address") {
output += "\n\n<div class=\"o-column o-extra-small--12 o-large--6 c-address-book__address-container is-focused\" data-qa-address-container-is-focused>\n\n";
;
}
else {
output += "\n\n<div class=\"o-column o-extra-small--12 o-large--6 c-address-book__address-container\" data-qa-address-container>\n\n";
;
}
output += "\n\n    <div class=\"o-row c-address-book__header--address\">\n\n        <div class=\"o-column o-medium--6 u-no-gutters\">\n\n            <h2 class=\"c-address-book__h2\">\n                ";
output += runtime.suppressValue((lineno = 15, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-address",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n            </h2>\n\n        </div>\n\n        <div class=\"o-column o-extra-small--12 o-medium--6 c-account__button-new u-no-gutters\">\n\n            <a href=\"#\" class=\"c-account__button-new--link js-address-new\" data-cm-element=\"account_address_create\">\n\n                <span class=\"c-account__button-new--copy\" data-qa-add-address-button>\n\n                    ";
output += runtime.suppressValue((lineno = 26, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-addNewAddress",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n                </span>\n\n            </a>\n\n        </div>\n\n    </div>\n\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"showErrors") && runtime.memberLookup(((lineno = 36, colno = 47, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["errors"]))),"location") == "js-address-edit-form" && runtime.memberLookup(((lineno = 36, colno = 108, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["errors"]))),"data")) {
output += "\n\n    ";
if(runtime.memberLookup(((lineno = 38, colno = 19, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["errors"]))),"data") == ("ERROR_ACCOUNT_POSTAL_CODE_INVALID_FOR_REGION" || "ERROR_ACCOUNT_REGION_INVALID_FOR_POSTAL_CODE")) {
output += "\n\n        ";
var t_1;
t_1 = (lineno = 40, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_form-error-postal-code-region-mismatch"]));
frame.set("formError", t_1, true);
if(frame.topLevel) {
context.setVariable("formError", t_1);
}
if(frame.topLevel) {
context.addExport("formError", t_1);
}
output += "\n\n    ";
;
}
else {
output += "\n\n        ";
var t_2;
t_2 = runtime.memberLookup(((lineno = 44, colno = 36, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["errors"]))),"data");
frame.set("formError", t_2, true);
if(frame.topLevel) {
context.setVariable("formError", t_2);
}
if(frame.topLevel) {
context.addExport("formError", t_2);
}
output += "\n\n    ";
;
}
output += "\n\n    <div class=\"c-form__field has-error\">\n\n        <div class=\"c-form-block\">\n\n            <p class=\"c-form-block__p\" data-qa-error-field=\"DUPLICATE_ADDRESS_FOUND\">\n\n                ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "formError"), env.opts.autoescape);
output += "\n\n            </p>\n\n        </div>\n\n    </div>\n\n    ";
;
}
output += "\n\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"newAddress")) {
output += "\n\n        <div class=\"o-column o-extra-small--12 c-address-form c-address-form__new\">\n\n            ";
env.getTemplate("./address-form.j2", false, "account/templates/partials/add-new-address-section.j2", null, function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
t_3.render(context.getVariables(), frame, function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
output += t_4
output += "\n\n        </div>\n\n    ";
})});
}
output += "\n\n    ";
env.getTemplate("./addresses-and-payments/no-address-message.j2", false, "account/templates/partials/add-new-address-section.j2", null, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
t_7.render(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
output += t_8
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/add-new-address-section.j2"] , dependencies)